import { z } from 'zod';
import { IdSchema, DateTimeSchema, PaginationParamsSchema, HttpOrInternalFileUrlSchema, } from '../../common';
export const TeacherSchema = z.object({
    id: IdSchema,
    email: z.string().email(),
    name: z.string(),
    phone: z.string().nullable(),
    city: z.string().nullable(),
    avatar: HttpOrInternalFileUrlSchema.nullable(),
    emailVerified: z.boolean(),
    createdAt: DateTimeSchema,
    profileId: IdSchema,
    branch: z.string(),
    agreedFee: z.number().nullable(),
    university: z.string().nullable(),
    graduationYear: z.number().int().nullable(),
    shortBio: z.string().nullable(),
});
export const CreateTeacherSchema = z.object({
    email: z.string().email(),
    password: z.string().min(8).regex(/[A-Z]/).regex(/[a-z]/).regex(/[0-9]/),
    name: z.string().min(2).max(120),
    phone: z.string().min(7).max(20),
    city: z.string().max(80).optional(),
    branch: z.string().min(1).max(80),
    agreedFee: z.coerce.number().nonnegative().optional(),
    university: z.string().max(160).optional(),
    graduationYear: z.coerce.number().int().min(1950).max(2100).optional(),
    shortBio: z.string().max(2000).optional(),
});
export const UpdateTeacherSchema = z.object({
    name: z.string().min(2).max(120).optional(),
    // Admin tarafından opsiyonel şifre sıfırlama — boş gönderilirse değişmez.
    password: z.string().min(8).regex(/[A-Z]/).regex(/[a-z]/).regex(/[0-9]/).optional(),
    phone: z.string().min(7).max(20).optional(),
    city: z.string().max(80).optional(),
    branch: z.string().min(1).max(80).optional(),
    agreedFee: z.coerce.number().nonnegative().nullable().optional(),
    university: z.string().max(160).nullable().optional(),
    graduationYear: z.coerce.number().int().min(1950).max(2100).nullable().optional(),
    shortBio: z.string().max(2000).nullable().optional(),
});
export const TeacherQuerySchema = PaginationParamsSchema.extend({
    limit: z.coerce.number().int().positive().max(500).default(20),
    search: z.string().optional(),
    branch: z.string().optional(),
});
// ============================================
// Web yayını (public tanıtım sitesi — Öğretmen Kadromuz)
// ============================================
// Admin liste satırı (cms): yayın durumu + web alanları + temel kimlik.
export const AdminWebTeacherSchema = z.object({
    userId: IdSchema,
    name: z.string(),
    branch: z.string(),
    avatar: z.string().nullable(),
    webPublished: z.boolean(),
    webPhotoUrl: z.string().nullable(),
    webBio: z.string().nullable(),
    webOrder: z.number().int(),
});
export const AdminWebTeacherListSchema = z.object({
    items: z.array(AdminWebTeacherSchema),
    total: z.number().int().nonnegative(),
});
// Admin: bir öğretmeni web'de yayınla/çıkar + foto/bio/sıra düzenle.
export const UpdateTeacherWebSchema = z.object({
    webPublished: z.boolean().optional(),
    webPhotoUrl: z.string().max(2048).nullable().optional(),
    webBio: z.string().max(2000).nullable().optional(),
    webOrder: z.coerce.number().int().min(0).max(9999).optional(),
});
// Public: öğretmen kartı.
export const PublicTeacherSchema = z.object({
    id: IdSchema,
    name: z.string(),
    branch: z.string(),
    photoUrl: z.string().nullable(),
    bio: z.string().nullable(),
});
export const PublicTeacherListSchema = z.object({
    items: z.array(PublicTeacherSchema),
    total: z.number().int().nonnegative(),
});
//# sourceMappingURL=teacher.js.map